import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "../../store/combineReducer";
import RequestTurns from "./requestTurns";
import RequestTurnCandidateAppointments from "./requestTurnCandidateAppointments";
import HistoryTurn from "./historyTurns";
import TurnsRequested from "./requestedTurns";
import ParticularClientTurns from "./particular-client-turns";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import "./turnos.scss";

const Turnos = () => {
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;

  const CUENTA: any = {
    COMPANY_ADMIN: <CompanyTurns />,
    RRHH: <CompanyTurns />,
    RRHH_APPOINTMENTS_AND_ABSENTEE: <CompanyTurns />,
    RRHH_APPOINTMENTS: <CompanyTurns />,
    CANDIDATE_APPOINTMENTS: <CompanyTurns />,
    PARTICULAR_CLIENT: <ParticularClientTurns />,
  };
  return CUENTA[chosenRole] ? CUENTA[chosenRole] : <></>;
};

// COMPANY ADMIN VIEW
const CompanyTurns = () => {
  // useStates
  const [currentTab, setCurrentTab] = useState("Solicitar");
  const [searchParams, setSearchParams] = useSearchParams("");
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;

  // useEffects
  useEffect(() => {
    const currentTable = searchParams.get("currentTab") || "";
    if (currentTable) {
      setCurrentTab(currentTable);
    }
  }, [searchParams]);

  // Helper function for setting tabs
  const handleTabClick = (tab: string) => {
    setCurrentTab(tab);
    setSearchParams({ currentTab: tab });
  };

  // Define tabs and components to render
  const tabs = [
    {
      id: "Solicitar",
      label: "Solicitar",
      component: chosenRole === 'CANDIDATE_APPOINTMENTS' ? RequestTurnCandidateAppointments : RequestTurns,
      icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M8 3.333v9.334M3.333 8h9.334"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
    {
      id: "Solicitudes",
      label: "Solicitudes",
      component: TurnsRequested,
      icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M14.667 8A6.667 6.667 0 1 1 8 1.333 6.667 6.667 0 0 1 14.667 8ZM8 5.333V8l2 2"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
    {
      id: "Historial",
      label: "Historial",
      component: HistoryTurn,
      icon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M13.333 2v12M2.667 2v12M2.667 6h10.666M2.667 10h10.666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
  ];

  // Find the current tab and its component
  const currentComponent = tabs.find(tab => tab.id === currentTab)?.component;

  return (
    <div className="main-container">
      <div className="atendoo-card">
        {/* Header Section */}
        <div className="turnos-header">
          <div className="header-top">
            <h6 className="subtitle">
              {chosenRole === 'CANDIDATE_APPOINTMENTS' ? "Turnos Postulantes" : "Turnos"}
            </h6>
            <InfoOffcanvas title="INFORMACIÓN DE TURNOS">
              <div>
                <h6>¿Cómo funcionan los turnos?</h6>
                <ul>
                  <li><strong>Solicitar:</strong> Programa nuevos turnos para empleados o postulantes</li>
                  <li><strong>Solicitudes:</strong> Revisa y gestiona las solicitudes pendientes</li>
                  <li><strong>Historial:</strong> Consulta todos los turnos anteriores y su estado</li>
                </ul>

                <h6>Tipos de turnos disponibles:</h6>
                <ul>
                  <li>Entrevistas laborales</li>
                  <li>Evaluaciones médicas</li>
                  <li>Revisiones periódicas</li>
                  <li>Consultas especializadas</li>
                </ul>
              </div>
            </InfoOffcanvas>
          </div>

          {/* Tabs Navigation */}
          <div className="tabs-container">
            <nav className="tabs-nav">
              {tabs.map((tab) => {
                // Check if component should be shown (same logic as original)
                const shouldShow = tab.component();
                return shouldShow ? (
                  <button
                    key={tab.id}
                    className={`tab-button ${currentTab === tab.id ? 'active' : ''}`}
                    onClick={() => handleTabClick(tab.id)}
                  >
                    <span className="tab-icon">{tab.icon}</span>
                    <span className="tab-label">{tab.label}</span>
                  </button>
                ) : null;
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {currentComponent && React.createElement(currentComponent)}
        </div>
      </div>
    </div>
  );
}

export default Turnos;